import { Box, Grid } from "@mui/material";
import accommodations from "../../../assets/images/accommodations.png";
import dresscode from "../../../assets/images/dresscode.png";

const Section2 = ({ isMobile, setOpen }) => {
  return (
    <Box
      style={{ padding: 20, backgroundColor: "#d9918b" }}
      sx={{ flexGrow: 1 }}
    >
      <Grid
        container
        alignItems="center"
        style={{
          height: "100%",
          backgroundColor: "#d9918b",
          border: "solid #f2efeb",
          borderRadius: 20,
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
      
        <Grid
          item
          size={12}
          style={{
            marginTop: 30,
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <h1
            style={{
              fontFamily: "BrushScriptOpti-Regular",
              color: "#f2efeb",
              fontSize: isMobile ? "7rem" : "9rem",
              transform: "rotate(-10deg)",
              margin: 0,
              fontWeight: 300,
            }}
          >
            Details
          </h1>
          <p></p>
        </Grid>
        <Grid
          item
          size={{ xs: 12, md: 6 }}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: 20,
            gap: 10,
            position: "relative",
          }}
        >
          <p
            style={{
              fontFamily: "Montserrat",
              color: "#810605",
              fontSize: isMobile ? "1.2rem" : "1.5rem",
              fontWeight: "bold",
              textAlign: "left",
              margin: 0,
              width: "100%",
            }}
          >
            ACCOMODATIONS
          </p>
          <p
            style={{
              fontFamily: "Montserrat",
              color: "#810605",
              fontSize: isMobile ? "1.2rem" : "1.5rem",
              textAlign: "left",
              margin: 0,
            }}
          >
            For your convenience, discounted guest rooms are available at Hotel
            Per La, just steps from the venue.</p> 
           <div
            style={{
            width: 250,
              height: 30,
              border: "solid #810605",
              borderRadius: 15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              marginTop: 20
            }}
          >
            <p style={{ fontFamily: "Montserrat", color: "#810605" }} onClick={() =>
                window.open(
                  "https://www.marriott.com/event-reservations/reservation-link.mi?id=1695752011853&key=CORP&app=resvlink",
                  "_blank"
                )
              }>
              CLICK HERE TO RESERVE
            </p>
          </div>
          <img
            src={accommodations}
            style={{
              position: "absolute",
              width: "40%",
              right: 10,
              maxWidth: 200,
              opacity: 0.7,
            }}
            alt="Accommodations"
          />
        </Grid>
        <Grid
          item
          size={{ xs: 12, md: 6 }}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: 20,
            gap: 10,
            position: "relative",
          }}
        >
          <p
            style={{
              fontFamily: "Montserrat",
              color: "#810605",
              fontSize: isMobile ? "1.2rem" : "1.5rem",
              fontWeight: "bold",
              textAlign: "left",
              margin: 0,
              width: "100%",
            }}
          >
            DRESS CODE
          </p>
          <p
            style={{
              fontFamily: "Montserrat",
              color: "#810605",
              fontSize: isMobile ? "1.2rem" : "1.5rem",
              textAlign: "left",
              margin: 0,
            }}
          >
            We kindly ask guests to wear cocktail attire, polished suits and
            dresses that feel refined without being too formal. As the evening
            may cool down, we recommend bringing an extra layer for warmth.
          </p>
          <img
            src={dresscode}
            style={{
              position: "absolute",
              width: "40%",
              right: 10,
              maxWidth: 200,
              opacity: 0.7,
            }}
            alt="Dress Code"
          />
        </Grid>
        <Grid item size={12} style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
          <div style={{ height: 30 }} />
          <div
            style={{
            width: isMobile ? "50%" : "20%",
              height: 30,
              border: "solid #810605",
              borderRadius: 15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <p style={{ fontFamily: "Montserrat", color: "#810605" }} onClick={() => setOpen(true)}>
              RSVP HERE
            </p>
          </div>
          <div style={{ height: 30 }} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Section2;
